/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

export type NumberInputMode = 'numeric' | 'decimal';

export const convertNumericInputValue = (
  value: string,
  inputMode: NumberInputMode,
): number | null => {
  if (value !== '' && !isNaN(parseFloat(value))) {
    return inputMode === 'numeric' ? parseInt(value, 10) : parseFloat(value);
  }

  return null;
};

export const getAllowedKeys = (
  inputMode: NumberInputMode = 'numeric',
): string[] => {
  const allowedKeys = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '-',
    'Backspace',
    'ArrowRight',
    'ArrowLeft',
    'Tab',
    'Home',
    'End',
    'PageDown',
    'PageUp',
    'Delete',
    ...(inputMode === 'decimal' ? ['.'] : []),
  ];
  return allowedKeys;
};
